import React, { useEffect } from "react";
import { ScrollMenu } from "react-horizontal-scrolling-menu";
import { Container, Grid } from "@material-ui/core";
import ServiceCard from "../cards/ServiceCard"; // Update the path as necessary

export function ServiceList(props) {
  const [items, setItems] = React.useState([]);

  useEffect(() => {
    setItems(props.service); // Assuming `service` is the prop passed to this component
  }, [props.service]);
  const container_style = {
    background: "white",
    margin: "0",
    backgroundColor: "white", //#ff6347
    display: "flex",
    justifyContent: "center",
  };

  // const text_style = {
  //   padding: "10px",
  //   margin: "0",
  // };

  return (
    <div style={container_style}>
      {/* <h3 style={text_style}>What services are you interested in?</h3> */}
      <ScrollMenu
        style={{
          display: "flex",
          justifyContent: "center",
          width: "fit-content",
        }}
      >
        {items.map((item) => (
          <Grid key={item._id} style={{ margin: "8px" }}>
            <ServiceCard service={item} />{" "}
            {/* Assuming you have a ServiceCard component */}
          </Grid>
        ))}
      </ScrollMenu>
    </div>
  );
}
